import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { db } from '../../../firebase';
import { collection, getDocs } from 'firebase/firestore';

import { useUser } from '../../../store/UserProvider';

import Loading from "../../Loading";

import styleClasses from '../css/mobile/MyPage.module.scss';

function MusicardSourcePopup({ open, setOpenPopup, handleTrackSelect, handleActivitySelect }) {
  const { user, userLoading } = useUser();

  const navigate  = useNavigate();
  
  const [uid, setUid]                       = useState(null);
  const [isLoading, setIsLoading]           = useState(true);
  const [isLoading2, setIsLoading2]         = useState(false);
  const [active, setActive]                 = useState(open ? styleClasses.active : '');
  const [showAlbum, setShowAlbum]           = useState(true);
  const [showTrack, setShowTrack]           = useState(false);
  const [showActivity, setShowActivity]     = useState(false);
  const [albumItems, setAlbumItems]         = useState([]);     // 앨범 목록
  const [trackItems, setTrackItems]         = useState([]);       // 선택된 앨범의 트랙 목록
  const [activityItems, setActivityItems]   = useState([]); // Activity 목록
  const [selectedAlbum, setSelectedAlbum]   = useState(null); // 선택된 앨범
  const [checkedAlbum, setCheckedAlbum]     = useState('');

  useEffect(() => {
    setActive(open ? styleClasses.active : '');
  }, [open])

  // 🔹 처음에는 앨범과 Activity 목록만 불러오기
  const fetchAlbumsAndActivities = useCallback(async () => {
    setIsLoading(true);
    try {
      let albums = [];
      const attrs = ["released", "unreleased"];
      for (const attr of attrs) {
        const albumsRef = collection(db, "users_data", uid, attr);
        const albumsSnapshot = await getDocs(albumsRef);
        albumsSnapshot.docs.forEach((albumDoc) => {
          const albumData = albumDoc.data();
          const albumId = albumDoc.id;
          albums.push({
            id: `${attr}-${albumId}`, // 고유 키 생성
            albumId,
            attribute: attr,
            albumTitle: albumData.title || albumData.name || "앨범 제목 없음",
            cover: albumData.cover || "", // 앨범 커버
          });
        });
      }
      const activityRef = collection(db, "users_data", uid, "activity");
      const activitySnapshot = await getDocs(activityRef);
      const activities = activitySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAlbumItems(albums);
      setActivityItems(activities);
    } catch (error) {
      console.error("아이템 가져오기 오류:", error);
    }
    setIsLoading(false);
  }, [uid]);

  // 🔹 로그인 확인
  useEffect(() => {
    if (userLoading) return;
  
    if (user?.userID) {
      setUid(user.userID);
    } else {
      navigate('/login');
    }
  }, [navigate, user?.userID, userLoading]);

  // 🔹 앨범 선택 시, 해당 앨범의 트랙들을 불러오기
  useEffect(() => {
    if (selectedAlbum) {
      const fetchTracks = async () => {
        try {
          setIsLoading2(true);
          const { attribute: attr, albumId } = selectedAlbum;
          const tracksRef = collection(db, "users_data", uid, attr, albumId, "tracks");
          const tracksSnapshot = await getDocs(tracksRef);
          let tracks = [];
          tracksSnapshot.docs.forEach((trackDoc, index) => {
            tracks.push({
              id: `${attr}-${albumId}-${trackDoc.id}-${index}`, // 중복 방지를 위해 index 추가
              ...trackDoc.data(),
            });
          });
          setTrackItems(tracks);
          setIsLoading2(false);
        } catch (error) {
          setIsLoading2(false);
          console.error("트랙 가져오기 오류:", error);
        }
      };
      fetchTracks();
    }
  }, [selectedAlbum, uid]);
  
  // 🔹 로그인 확인 후 앨범/액티비티 조회
  useEffect(() => {
    if (!uid) return;
    fetchAlbumsAndActivities();
  }, [fetchAlbumsAndActivities, uid]);

  return (
    <>
      <div className={`${ styleClasses.backDropMobile } ${ active }`} onClick={ () => { setActive(''); setOpenPopup(false); } }/>
      <div className={`${ styleClasses.musicardSourcePopupMobile } ${ active }`}>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.header }>
            <div className={ styleClasses.title }>
              <h1>소스 선택</h1>
            </div>
            <div className={ styleClasses.closeButton }>
              <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                <div className="commonIcon mobile">
                  <i className="closeWhite w32"></i>
                </div>
              </button>
            </div>
            <div className={`commonForm ${ styleClasses.selectOption }`}>
              <div className={`formRow`}>
                <div className="fieldBox checkBox">
                  <div className="eachBox">
                    <input type="radio" name="option" id="option1" checked={ showAlbum } onChange={ () => { setShowAlbum(true); setShowTrack(false); setShowActivity(false); setTrackItems([]); setCheckedAlbum(''); }} />
                    <label htmlFor="option1">앨범 목록</label>
                  </div>
                  <div className="eachBox">
                    <input type="radio" name="option" id="option2" checked={ showActivity } onChange={ () => { setShowAlbum(false); setShowTrack(false); setShowActivity(true); setTrackItems([]); setCheckedAlbum(''); }} />
                    <label htmlFor="option2">Activity 목록</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${ styleClasses.content } ${ isLoading && styleClasses.noScroll }`}>
            <div className={ styleClasses.sourceContent }>
            {
              isLoading
              ?
              <Loading />
              :
              (
              <div className={ styleClasses.list }>
                <div className={ styleClasses.eachRow }>
                  <div className={`${ styleClasses.column } ${ showAlbum ? styleClasses.active : undefined } `}>
                    {/* <h2>앨범 목록</h2> */}
                    {
                      showAlbum
                      ?
                      albumItems.length > 0
                      ?
                      (
                      albumItems.map((album, index) => (
                        <label htmlFor={`${album.id}-${index}`} key={`${album.id}-${index}`} checked={ album.id === checkedAlbum } className={styleClasses.sourceItem} onClick={() => setSelectedAlbum(album)}
                        >
                          <input type="radio" name='eachAlbum' id={`${album.id}-${index}`} value={ album.id } onChange={ (e) => { setCheckedAlbum(album.id); setShowTrack(true); setShowAlbum(false); } } />
                          {album.cover && (
                            <img src={album.cover} alt={album.albumTitle} />
                          )}
                          <span>{album.albumTitle || "앨범"}</span>
                        </label>
                      ))
                      )
                      :
                      (
                        <p>앨범이 없습니다.</p>
                      )
                      :
                      null
                    }
                  </div>
                  <div className={`${ styleClasses.column } ${ showTrack ? styleClasses.active : undefined } `}>
                    <div className={ styleClasses.tracks }>
                      {
                        isLoading2
                        ?
                        <Loading />
                        :
                        showTrack
                        ?
                        (
                          trackItems.length > 0
                          ?
                          (
                            <>
                              <button className={ styleClasses.backButton } onClick={ () => { setShowAlbum(true); setShowTrack(false); } }>
                                <div className="commonIcon mobile">
                                  <i className='leftWhite w24'></i>
                                </div>
                                목록으로 이동
                              </button>
                              {
                                trackItems.map((track, index) => (
                                  <div key={`${track.id}-${index}`} className={ styleClasses.sourceTrackItem }
                                    onClick={ () => handleTrackSelect(track.url, selectedAlbum.cover, track.title) } >
                                    <span>{ track.name || track.title || "트랙" }</span>
                                    <span className={ styleClasses.selection }>선택</span>
                                  </div>
                                ))
                              }
                            </>
                          )
                          :
                          (
                            checkedAlbum !== '' ? <p>트랙이 없습니다.</p> : null
                          )
                        )
                        :
                        null
                      }
                    </div>
                  </div>
                  <div className={`${ styleClasses.column } ${ showActivity ? styleClasses.active : undefined } `}>
                    <div className={ styleClasses.tracks }>
                      {/* <h2>Activity 목록</h2> */}
                      {
                        showActivity
                        ?
                        activityItems.length > 0
                        ?
                        (
                          activityItems.map((item, index) => (
                            <div key={`${item.id}-${index}`} className={ styleClasses.sourceTrackItem } onClick={ () => handleActivitySelect(item) }>
                              <img 
                                src={
                                  item.photo 
                                    ? item.photo 
                                    : item.videoId 
                                      ? `https://img.youtube.com/vi/${item.videoId}/0.jpg` 
                                      : '/assets/images/Background Test 1.png'
                                }
                                alt={item.title || item.name} 
                                style={{ width: '50px', height: '50px', marginRight: '0.5rem' }} 
                              />
                              <span>{ item.title || item.name || "Activity Item" }</span>
                              <span className={ styleClasses.selection }>선택</span>
                            </div>
                          ))
                        )
                        :
                        (
                          <p>Activity 아이템이 없습니다.</p>
                        )
                      :
                      null
                    }
                    </div>
                  </div>
                </div>
              </div>
              )
            }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MusicardSourcePopup;